import React from 'react';
import { Outlet, useLocation, Link } from 'react-router-dom';
import Navigation from './Navigation';
import Footer from './Footer';
import CustomCursor from './CustomCursor';

const Layout: React.FC = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(segment => segment !== '');

  const getBreadcrumbLabel = (segment: string, index: number): string => {
    if (segment === 'product' && pathSegments[index + 1]) {
      return 'Product Details';
    }

    // Capitalize first letter and replace hyphens with spaces
    return segment.charAt(0).toUpperCase() + segment.slice(1).replace(/-/g, ' ');
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#0A0A0A]">
      {/* Custom Cursor */}
      <CustomCursor />

      {/* Header */}
      <Navigation />

      {/* Main Content */}
      <main className="flex-grow">
        {pathSegments.length > 0 && (
          <div className="container mx-auto px-4 py-4 text-sm">
            <div className="flex items-center text-[var(--color-muted)]">
              <Link to="/" className="hover:text-white transition-colors">Home</Link>
              {pathSegments.map((segment, index) => {
                const url = `/${pathSegments.slice(0, index + 1).join('/')}`;
                const isLast = index === pathSegments.length - 1;

                return (
                  <React.Fragment key={index}>
                    <span className="mx-2">/</span>
                    {isLast ? (
                      <span className="text-white">{getBreadcrumbLabel(segment, index)}</span>
                    ) : (
                      <Link to={url} className="hover:text-white transition-colors">
                        {getBreadcrumbLabel(segment, index)}
                      </Link>
                    )}
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        )}
        <Outlet />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Layout;
